var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13460_38069)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 0.5H0V29.5H29V0.5ZM19.8751 21.2816L22.9712 7.75745L22.9714 7.75739C23.1597 6.94035 22.3825 6.25186 21.6601 6.58649L6.57408 13.5543C5.83354 13.8952 5.80318 14.9955 6.51947 15.388L9.5791 17.0608L18.6853 10.3437C18.7823 10.2731 18.8794 10.3567 18.8855 10.4532L11.2544 18.1739C11.0662 18.3669 10.957 18.6308 10.957 18.9074V22.4847C10.957 23.5078 12.2318 23.8874 12.7356 23.0123L14.5872 19.8018L18.503 21.9443C19.0555 22.2467 19.7294 21.9186 19.8751 21.2816Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13460_38069"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramFooter);
export default __webpack_public_path__ + "static/media/telegram-footer.333718249e324b7daec40bf92677e7ab.svg";
export { ForwardRef as ReactComponent };